import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Helpers from "../base/Helpers";

var discountCookie = Helpers.getCookie("discount_code")

const selectors = {
  discountContainer: '#discountContainer',
  cartContainer: '.cart-wrapper__inner-inner .container',
  discountInput: '#discountInput',
  discountSubmit: '#discountSubmit',
  discountRemove: '#discountRemove',
  discountError: '#discountError',
  discountForm: '.cart-recap'
}
//if enter is pressed dont redirect to checkout
function preventSubmit() {
  $(document).on('keyup keypress', $(selectors.discountForm), function(e) { 
    if(e.keyCode == 13) {
      e.preventDefault();
      return false;
    }
  });
}

function unregisterDiscount() {
  $(selectors.discountSubmit).off('click');
  $(selectors.discountRemove).off('click');
}

function registerDiscount() {
    $(selectors.discountSubmit).on('click', e => {
      $(selectors.discountError).hide()
      const discount_code = $(selectors.discountInput).val()
      handleDiscountSubmit(discount_code);
    })
    $(selectors.discountInput).on('keyup', function (e) {
      const discount_code = $(selectors.discountInput).val()
      if (e.keyCode === 13) {
        handleDiscountSubmit(discount_code);
      }
    })
    $(selectors.discountRemove).on('click', e => {
      $(selectors.discountContainer).addClass('is-loading');
      Helpers.setCookie("discount_response", false, 365);
      Helpers.setCookie("discount_code", "", 365);
      Helpers.updateCartAttributes("", "", "", true)
      document.dispatchEvent(new CustomEvent('discount:check', {detail: { discount_amount: '', code_valid: false, discount_code: '' }}))
    });
}

function showErrorMsg(data, isPanty) {
  var discount_translations = ''
  if(window.__discountzMetafields){
   discount_translations = window.__discountzMetafields["translations_de"]
  }
  if (isPanty === false) {
    if (discount_translations) { 
      if(data.code == "MIN_QUANTITY" ){
        $(selectors.discountError).html(discount_translations['VALIDATION_'+ data.code].replace("{missingQuantity}", data.data.missingQuantity))  
      } else if(data.code == "MIN_SUBTOTAL" ){ 
        var amount = data.data.missingSubtotal 
        var missingAmount =  ( amount / 100).toFixed(2).replace(/\./, ',') + ' €'
        $(selectors.discountError).html(discount_translations['VALIDATION_'+ data.code].replace("{missingSubtotal}", missingAmount))
      } else {
        $(selectors.discountError).html(discount_translations['VALIDATION_'+ data.code]);
      }
    }else {
      $(selectors.discountError).html('Der Gutscheincode ist nicht gültig.');
    }
  } else {
    let pantySavings = window.languages.pantySavings
    $(selectors.discountError).html(pantySavings);
  }
  $(selectors.discountError).addClass('alert')
  $(selectors.discountError).show()
}

function checkIfPanty() {
  const pantyScript = document.getElementById('pantyProductScript');
  
  if (!!!pantyScript) {
    return false
  }
  const variableJsonPanty = JSON.parse(pantyScript.textContent);
  const hasTagsPanty = variableJsonPanty.hasPantyTag
  if (hasTagsPanty === true) {
    return true
  }else {
    return false
  }
}
const hasPanty = checkIfPanty()

function handleDiscountSubmit(discount_code) {
  const url = '/apps/discountz-api-new'
  if (!!discount_code) {
    $(selectors.discountContainer).addClass('is-loading');
    $(selectors.cartContainer).addClass('is-loading--skeleton');
    $.getJSON('/cart.js', function(cart) {
      $.ajax({
          url: url,
          method: 'POST',
          crossDomain: true,
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify({
            locale: 'de',
            cart: cart,
            code: discount_code
          }),
          success: function (response) {
            Helpers.setCookie("discount_response", response.valid, 365);
            if (response.valid == true) {
              Helpers.setCookie("discount_code", discount_code, 365);
              $.ajax({
                url: "/discount/" + encodeURIComponent(discount_code),
                cache: false
              }).then(function(){
                // let totalLineLevelDiscountCart = cart.original_total_price - response.discount
                // let totalLineLevelDiscount = response.subtotal
                // if (response.subtotal !== totalLineLevelDiscountCart) {
                //   totalLineLevelDiscount = cart.original_total_price - response.discount
                // }else {
                //   totalLineLevelDiscount = response.subtotal
                // }
                if(cart.attributes){
                  Helpers.updateCartAttributes(discount_code, response.discount, response.subtotal, true).then(function(){
                    $(selectors.cartContainer).removeClass('is-loading--skeleton');
                  })
                  if(cart.attributes.discount_code != undefined || cart.attributes.discount_code == discount_code ){
                    $(selectors.discountContainer).removeClass('is-loading');
                    $(selectors.cartContainer).removeClass('is-loading--skeleton');
                  }
                }
              })
            } else {
              if(hasPanty == true){
                showErrorMsg(response, true)
              }else {
                showErrorMsg(response, false)
              }
            
              $(selectors.discountContainer).removeClass('is-loading');
              $(selectors.cartContainer).removeClass('is-loading--skeleton');
              Helpers.setCookie("discount_code", '', 365);
            }
            document.dispatchEvent(new CustomEvent('discount:check', {
              detail: { 
                discount_amount: response.discount? response.discount : '',
                code_valid: response.valid,
                discount_code: discount_code
              }}))
          },
          error: function (xhr, status) {
            console.log("error", status);
          }
      });
    });
  }
}
let clubDiscountIdentifier =''
let clubDiscountSecondIdentifier =''
if (!!window.theme.clubDiscountIdentifier) {
  clubDiscountIdentifier = window.theme.clubDiscountIdentifier.toLowerCase()
}
if (!!window.theme.clubDiscountSecondIdentifier) {
  clubDiscountSecondIdentifier = window.theme.clubDiscountSecondIdentifier.toLowerCase()
}

function checkClubCookie() {
  return Helpers.getDiscount().then(function (cookie) {
    if (!!clubDiscountIdentifier || !!clubDiscountSecondIdentifier) {
      if (!!cookie && (cookie.toLowerCase().includes(clubDiscountIdentifier) || cookie.toLowerCase().includes(clubDiscountSecondIdentifier))) {
        return cookie;
      } else {
        return false;
      }
    }
  });
}

function checkClubCookieDiscount() {
  checkClubCookie().then(function (club_discount) {
    const discountLabelSet = document.querySelector('.toggle-set-label-savings-club')
    const dicountLabels = document.querySelectorAll('.toggle-product-label-savings-club')
    const normalPriceSticky = document.getElementById(`normalPriceSticky`);
    
    if (!!!club_discount) {
      if (!!normalPriceSticky) {
        normalPriceSticky.classList.remove('hidden_price');
      }
    }

    if (!!club_discount) {
      let cookieIdentifier = ''

      if (!!clubDiscountIdentifier) {
        if (club_discount.toLowerCase().includes(clubDiscountIdentifier)) {
          cookieIdentifier = clubDiscountIdentifier
        }
      }
     
      if (!!clubDiscountSecondIdentifier) {
        if (club_discount.toLowerCase().includes(clubDiscountSecondIdentifier)) {
          cookieIdentifier = clubDiscountSecondIdentifier
        }
      }

      if (!!cookieIdentifier) {
        const dicountLabelsSpan = document.querySelectorAll(`.product-label-club-price-${cookieIdentifier}`)
        const dicountPercentageSpan = document.querySelectorAll(`.product-label-club-percentage-${cookieIdentifier}`)
        
        if (!!dicountLabels) {
          dicountLabels.forEach(label => {
            label.classList.remove('hidden');
          })
        }
        
        if (!!discountLabelSet) {
          discountLabelSet.classList.add('set-label-savings-club-active')
        }

        if (!!dicountLabelsSpan) {
          dicountLabelsSpan.forEach(span =>{
            span.classList.remove('hidden')
            span.classList.add('product-label-club--active')
          })
        }
        if (!!dicountPercentageSpan) {
          dicountPercentageSpan.forEach(span =>{
            span.classList.remove('hidden')
          })
        }

      }
    }
  })
}


export function checkDiscount(discount_code, cart) {
  if (!!discount_code) {
    $.ajax({
        url: '/apps/discountz-api-new',
        method: 'POST',
        crossDomain: true,
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify({
          locale: 'de',
          cart: cart,
          code: discount_code
        }),
        success: function (response) {
          Helpers.setCookie("discount_response", response.valid, 365);
          if (response.valid == false) {
            Helpers.setCookie("discount_code", "", 365);
            Helpers.updateCartAttributes("", "", "", true)
          } else {
            // let totalLineLevelDiscountCart = cart.original_total_price - response.discount
            // let totalLineLevelDiscount = response.subtotal
            // if (response.subtotal !== totalLineLevelDiscountCart) {
            //   totalLineLevelDiscount = cart.original_total_price - response.discount
            // }else {
            //   totalLineLevelDiscount = response.subtotal
            // }

            Helpers.updateCartAttributes(discount_code, response.discount, response.subtotal, false).then(function(){
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  // this will indicate that the discount was refreshed and 
                  // doese not neet to be checked again 
                  discountz: true
                }
              }));
            })
          }
          document.dispatchEvent(new CustomEvent('discount:check', {
            detail: { 
              discount_amount: response.discount? response.discount : '',
              code_valid: response.valid,
              discount_code: discount_code
          }}))
        },
        error: function (xhr, status) {
          console.log("error", status);
        }
    });
  }
}

function checkDiscountCodeUrl (discount) {
  if (discount) {
    fetch('/apps/discountz-api-new/discount-info', {
      method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code: discount }),
    })
    .then((response) => response.status === 200 ? response.text() : null)
    .then(data => {
      var result = {}
      try {
        result = JSON.parse(data)
      } catch (error) {
        result.status = "NOT_ACTIVE"
      }
      if (result && result.status === 'ACTIVE'){
        Helpers.setCookie("discount_response", true, 365);
        Helpers.setCookie("discount_code", discount, 365);
        document.dispatchEvent(new CustomEvent('discount:check:url', {
          detail: { 
          discount_code: discount
        }}))
      }else {
        Helpers.setCookie("discount_response", false, 365);
      }
    })
  }
}

// check for param is set
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const urlParamsDiscount = urlParams.get('discount')

// check for param is given && cookie isnt set
document.addEventListener("DOMContentLoaded", function () {
  if (urlParams.has('discount') && !discountCookie) {
    checkDiscountCodeUrl(urlParamsDiscount)
  }
});

document.addEventListener("DOMContentLoaded", function () {
  preventSubmit()
  registerDiscount();
  if(window.theme.pageType == 'cart'){
    if(!!discountCookie){
      handleDiscountSubmit(discountCookie);
    }
  }
  checkClubCookieDiscount()
});

document.addEventListener("theme:loading:end", function () {
  checkClubCookieDiscount()
});

document.addEventListener('cart:rerendered', function(event){
  if(!!discountCookie && !event.detail){
    $.getJSON('/cart.js', function(cart) {
      checkDiscount(discountCookie, cart)
    })
  }
  unregisterDiscount();
  registerDiscount()
});

document.addEventListener('product:added', function(event){
  var discountCookieNew = Helpers.getCookie("discount_code")
  if(window.theme.pageType == 'cart'){
    if(!!discountCookieNew){
      $.getJSON('/cart.js', function(cart) {
        checkDiscount(discountCookieNew, cart)
      })
    }
    unregisterDiscount();
    registerDiscount()
  }
});
document.addEventListener('discount:check', function(event){
  document.dispatchEvent(new CustomEvent('replace:banner'))
})